export enum ModalType {
    Name = 'Name',
    Nickname = 'Nickname',
    Email = 'Email',
    Phone = 'Phone',
    Pin = 'Pin',
    Address = 'Address'
}
